import { animate, utils, createDraggable, spring, onScroll } from 'animejs';

const animeHoverPopup = () => {
    const triggers = document.querySelectorAll('.reference-trigger sup');

        // Helper function to calculate position
        function showTooltip(trigger, tooltipId) {
            const tooltip = document.querySelector(tooltipId);
            
            if (!tooltip) return; // Safety check

            // Apply styles to show and position the sibling
            tooltip.style.display = 'block';
        }

        function getMatchingTooltip(selectorElement) {

            const selectorClassList = selectorElement.classList;
    
            
            // Find class that indicates the name (e.g., block_profile--name-aaron)
            // We look for classes starting with "block_profile--name-"
            let identifier = '';
            for (let className of selectorClassList.values()) {
                if (className.startsWith('tooltip-')) {
                    identifier = className; // e.g., 'block_profile--name-aaron'
                    break;
                }
            }

            console.log('identifier')
            console.log(identifier)

            if (!identifier) return null;

            return `.reference-text.${identifier}`;
        }

        triggers.forEach(trigger => {
            // Determine the associated tooltip ID based on the trigger's ID
            // Assuming naming convention: Trigger="ref-1", Tooltip="tooltip-ref-1"
            const targetId = getMatchingTooltip(trigger.parentElement)

            // Event: Mouse Enter
            trigger.addEventListener('mouseenter', (event) => {
                showTooltip(event.target, targetId);
            });

            // Event: Mouse Leave
            trigger.addEventListener('mouseleave', (event) => {
                const tooltip = document.querySelector(targetId);
                if(tooltip) tooltip.style.display = 'none';
            });
            
            // Handle case where mouse moves off the trigger but onto the tooltip
            // We grab the tooltip again inside the listener to attach an event to it
            trigger.addEventListener('mouseover', (event) => {
                const tooltip = document.querySelector(targetId);
                if(tooltip) {
                    tooltip.addEventListener('mouseleave', () => {
                        tooltip.style.display = 'none';
                    }, { once: true }); // Run only once per hover event
                }
            });
        });
} 

export { animeHoverPopup } 